import { Injectable, inject } from '@angular/core';
import { ApiEndpointConfigService, ApiEndpointService } from '@rci/self-serve-shared';
import { NEW_OFFERS_API, PPC_FLOW_URL } from '@rci/self-serve-fido/app.constant';

@Injectable()
export class TargetedOffersConfigServiceFactory {
  private readonly apiConfig = inject(ApiEndpointService);
  private readonly apiEndpointConfigService = inject(ApiEndpointConfigService);

  applicationId = 'Fido.ca';

  get api() {
    return {
      buyflowApiBaseUrl: '/bfa-api/',
      viewOfferUrl: this.apiEndpointConfigService.oneClickPpcUrl,
    };
  }

  get moreOffersUrl() {
    return PPC_FLOW_URL;
  }

  get baseApiUrl(): string {
    return `${this.apiConfig.promotionsBaseUrl}accounts/`;
  }

  get brtSwitchId(): string {
    return NEW_OFFERS_API;
  }

  readonly contentPageName = 'overview';
}
